<template>
    <div id="app" class="user_margin">
        <navbar />
        <div class="container-fluid text-center g-0">
            <div class="m-auto">
                <div class="zag d-flex row">
                    <div class="container-fluid align-self-center zag-txt">ИНФОРМАЦИЯ</div>
                </div>

                <div v-if="emptyPage && (emptyPage.name || emptyPage.description || emptyPage.files.length > 0)">
                    <div class="d-flex row mt-3 justify-content-center ">
                        <p class="color-red text-center name">
                            {{ emptyPage.name }}
                        </p>
                        <p v-html="this.emptyPage.description" class="color-black text-center">

                        </p>
                    </div>
                </div>

                <div class="me-3" v-if="emptyPage.files.length > 0">
                    <div class="row ms-3 justify-content-center">
                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-12 p-3"
                            v-for="(file, index) in this.emptyPage.files" :key="index">
                            <div class="card h-100 border">
                                <div class="card-body h-100 d-flex flex-column">
                                    <img :src="`/api/getFile/${file}`" class="card-img-top" alt="...">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-3" v-if="!emptyPage || (!emptyPage.name && !emptyPage.description && emptyPage.files.length <= 0)">
                    <p class="f-16 text-center color-red">В разработке.</p>
                </div>
            </div>
        </div>
    </div>
    <contactUs />
    <footerBar />
</template>

<script>
import Navbar from './Navbar';
import FooterBar from './Footer';
import ContactUs from './ContactUs';
import http from "../http-common";

export default {
    name: 'EmptyPage',
    components: {
        Navbar: Navbar,
        FooterBar: FooterBar,
        ContactUs: ContactUs,
    },
    data() {
        return {
            emptyPage: {
                name: "",
                description: "",
                files: []
            },
        };
    },
    methods: {
        getEmptyPage() {
            http
                .get("/emptyPage")
                .then(response => {
                    if (response.data) {
                        this.emptyPage = response.data;
                        if (!this.emptyPage.files) {
                            this.emptyPage.files = [];
                        }
                    }
                })
                .catch(e => {
                    console.log(e);
                    window.location.href = '/notFound';
                });
        }
    },
    mounted() {
        this.getEmptyPage();
    }
}
</script>

<style scoped>
.card {
    background: #fff;
    box-shadow: 0 14px 28px rgba(60, 60, 60, 0.25), 0 10px 10px rgba(60, 60, 60, 0.25);
}

.card-img-top {
    object-fit: cover;
}

p {
    white-space: pre-line;
}

.name {
    font-size: 24pt;
    font-family: 'Playfair Display';
    font-weight: bold;
}

.zag {
    height: 200pt;
    font-size: 30pt;
    font-weight: bold;
    color: #fff;
    letter-spacing: 0.5pt;
    background-image: url("../assets/zag.jpg");
    background-size: cover;
}

.f-16 {
    font-family: 'Playfair Display';
    font-weight: bold;
}
</style>
